import { Component, Event, EventEmitter, h, Fragment, Prop, Host } from '@stencil/core';
import { ButtonStyle } from '../../../atoms/rentware-button/types';
import { t } from '../../../../redux/utils';

@Component({
  tag: 'rentware-cart-template-timer',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareCartTemplateTimer {
  @Prop() expired: boolean;
  @Event() clickForOpenIndex: EventEmitter;

  handleCloseButtonClick = () => {
    this.clickForOpenIndex.emit(1); // open accordion index of articles
  };

  get title() {
    if (this.expired) {
      return t('cart.timeRanOut');
    }

    return t('cart.minutesLeft');
  }

  get info() {
    if (this.expired) {
      return t('cart.allArticlesReleased');
    }

    return t('cart.backToCart');
  }

  render() {
    return (
      <Host class="RCTDTimer">
        <rtr-pragotron />
        <rentware-spacer size="M" />
        <span class="RCTDInfoBold">{this.title}</span>
        <rentware-spacer size="M" />
        <span>{t('cart.yourCartReserved')}</span>
        {!this.expired && (
          <Fragment>
            <rentware-spacer size="M" />
            <rentware-button appearance={{ style: ButtonStyle.Inverse }} onClick={this.handleCloseButtonClick} buttonText={this.info} />
          </Fragment>
        )}
      </Host>
    );
  }
}
